import type CK from '~/types/contentking';
import useUserRole from './useUserRole';
import GraphQL from '~/types/graphql';



function useCanSetWebsiteDefaultAlerts(accountId: CK.AccountId | null, legacyUserId: string | null, accountType: GraphQL.AccountType | null) {
	const role = useUserRole(accountId, legacyUserId);
	const allowedRoles = [
		GraphQL.UserRole.Admin,
		GraphQL.UserRole.Manager
	];

	const allowedAccountTypes = [
		GraphQL.AccountType.EndUser,
		GraphQL.AccountType.Universal,
	];

	return (role && allowedRoles.includes(role)) && (accountType && allowedAccountTypes.includes(accountType))
}

export default useCanSetWebsiteDefaultAlerts;
